// @ts-check
import React from "react"
import BroadcastContext from "../broadcast/Context"

/**
 *
 * @param {Broadcastable} broadcast
 */
function filter(broadcast, { when }) {
    if (!when) return broadcast.channel === "property"
    return broadcast.channel === "property" && when(broadcast)
}

export default function PropertyBroadcastContext(props) {
    return <BroadcastContext {...props} when={broadcast => filter(broadcast, props)} />
}



// WEBPACK FOOTER //
// ./src/features/editor/properties/PropertiesContext.js